import React from "react";
import { Flex } from "antd";
import { ActionButtonStyled } from "./ActionRow.styles";


const ActionRow = ({ label, onClick, disabled, children }) => (
  <Flex align="center" gap={8}>
    {label}
    <ActionButtonStyled
      buttonType="primary"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </ActionButtonStyled>
  </Flex>
);

export default ActionRow;
